/**
 * These consts represent features running in enrollment client
 *
 * Each experiment has the following possible fields
 * 1. name - Name of experiment
 * 2. feature_test_name - Test associated with feature for tracking metrics
 * 3. attributes - Filter to further restrict who can be bucketed in an experiment
 * 4. variants - Each key value pair represents the different possible variant/buckets
 * 5. events - Events tied to an experiment that we can trigger through code
 *
 * Example
 * export const CUSTOM_SWIP = {
 *   name: 'mobile_custom_swip',
 *	 feature_test_name: 'mobile_custom_swip_test',
 *	 attributes: {
 *	   chime_employee: 'chime_employee',
 *   },
 *	 variations: {
 *		 control: 'control',
 *		 test: 'custom_swip',
 *	 },
 *	 events: {
 *		 edit_cta_tapped: 'Edit CTA Tapped',
 *		 swip_turned_on: 'swip_turned_on',
 *	 },
 * };
 *
 * Remember to always make 2 flags for each feature: one in Dev project (Fullstack project for Dev/QA environments), and one in Chime Fullstack (Production).
 * In the code you need to create only one, as we use different datafile for different environments (check config files).
 *
 * Remember that you can have only one enabled feature test for a feature flag
 * and feature test variations' ratio takes precedence over feature rollout.
 *
 * When you call isFeatureEnabled from Optimizely you automatically bucket the user into the corresponding feature test.
 * Activating the feature test and choosing variations is handled on Optimizely side and we don't have to do anything in the client to make it work.
 * We only check isFeatureEnabled, optionally get feature variable, and then send events for metrics.
 */

export const USE_TOGGLE_ENROLLMENT_DOWN_PAGE = {
  name: 'toggle_enrollment_down_page',
};
